import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material';
import {
  PollQuestion,
  ResponseValue,
  User,
  Voter,
  VoterSelect
} from '../../types';
import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';

import VoterListControl from '../Voters/VoterListControl';
import { db } from '../../firebase';
import useAuth from '../../hooks/useAuth';

interface PollVoterSelectorDialogProps {
  pollId: string;
  question: PollQuestion;
  handleInputChange: (question: string, value: ResponseValue) => void;  
}

const PollVoterSelectorDialog: React.FC<PollVoterSelectorDialogProps> = ({ pollId, question, handleInputChange }) => {
  const { user, loading } = useAuth();
  
  const [selectedVoterName, setSelectedVoterName] = useState<string>('');
  const [hadResponded, setHadResponded] = useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  
  useEffect(() => {
    if (selectedVoterName) {
      handleInputChange(question.text, selectedVoterName);
    }
  }, [selectedVoterName]);

  const onSelect = async (voter: Voter, user: User) => {
    handleClose();

    if ((question as VoterSelect).checkHasResponded) {
      const voterTabulationPath =
        `tabulationsV2/${user.dashboard}/regions/${voter.region}/`
        + `provinces/${voter.province}/districts/${voter.district}/`
        + `cities/${voter.city_municipality}/barangays/${voter.barangay}/`
        + `precincts/${voter.precinct}/voters/${voter.name}`;
      const voterTabulationDocRef = doc(db, voterTabulationPath);
      const voterTabulationDocSnapshot = await getDoc(voterTabulationDocRef);
      if (voterTabulationDocSnapshot.exists()) {
        setHadResponded(true);
      } else {
        setHadResponded(false);
      }
    }

    setSelectedVoterName(voter.name);
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <TextField
          fullWidth
          label={question.text}
          margin="normal"
          value={selectedVoterName}
          onChange={(e) => setSelectedVoterName(e.target.value)}
          InputProps={{
            readOnly: (question as VoterSelect).selectFromListOnly,
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickOpen}
          style={{ marginLeft: 10, paddingLeft: 20, paddingRight: 20, height: '100%' }}
        >
          Select
        </Button>
      </Box>
      {hadResponded && selectedVoterName && (
        <Typography variant="body2" color="orange">
          {selectedVoterName} have already responded to this poll
        </Typography>
      )}
      <Dialog
        fullWidth
        maxWidth={'md'}
        open={openDialog}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle>Select Voter</DialogTitle>
        <DialogContent>
          <VoterListControl
            onSelect={(voter) => onSelect(voter, user!)}
            city_municipality={(question as VoterSelect).voterMunicipality}
            province={(question as VoterSelect).voterProvince}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );  
};

export default PollVoterSelectorDialog;
